import {
  Box,
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import { type SxProps, type Theme } from "@mui/material/styles";
import { NavLink } from "react-router-dom";

import EnvPicker from "./env/env-picker";
import { CROWN_MODULES } from "./modules";

const styles = {
  root: {
    width: 240,
    alignSelf: "stretch",
    borderRight: 1,
    borderColor: "divider",
    p: 2,
    boxSizing: "border-box",
  },
  title: {
    mb: 2,
  },
  list: {
    mt: 2,
  },
  envHint: {
    mt: 1,
    display: "block",
  },
} satisfies Record<string, SxProps<Theme>>;

/**
 * Left navigation rail for the Crown data import hub.
 *
 * Renders the hub title, the environment picker, and a link for each
 * registered Crown module. Links use `NavLink` so the active module is
 * reflected in the router state.
 */
const CrownDataSidebar = () => {
  return (
    <Box sx={styles.root}>
      <Typography variant="h6" sx={styles.title}>
        Crown Data Import
      </Typography>
      <EnvPicker />
      <Typography color="text.secondary" variant="caption" sx={styles.envHint}>
        Switching environment may require logging in to that environment.
      </Typography>
      <List sx={styles.list}>
        {CROWN_MODULES.map((m) => (
          <ListItemButton
            key={m.path}
            component={NavLink}
            to={`/crown-data-import/${m.path}`}
          >
            <ListItemText primary={m.label} />
          </ListItemButton>
        ))}
      </List>
    </Box>
  );
};

export default CrownDataSidebar;
